import React, { useContext } from 'react';
import styles from '../farmFieldFlow.module.scss';
import { FormType } from 'enums/FieldTypeEnums';
import FieldsRow from 'shared/components/FieldsRow';
import {
  GetCropResidueInitialField,
  GetCropResidueResidueManagementField,
} from '../stage4FarmData';
import {
  DynamicFields,
  STAGE_4,
} from 'constants/FarmboxConstants/stage4.constants';
import { CropResidue } from 'models/Farmbox/field.model';
import { useFieldArray, useFormContext } from 'react-hook-form';
import COButton from 'shared/components/COButton';
import { ReactComponent as AddIcon } from 'assets/icons/add_enclosed.svg';
import { HelpDeskContext } from 'context/HelpDeskContext';
import HelpdeskService from 'services/HelpdeskService/Helpdesk.service';
import { useParams } from 'react-router-dom';
import isProductDisabled from 'shared/utils/isProductDisabled';
import clsx from 'clsx';

const CropResidueSection = () => {
  const { watch, trigger } = useFormContext();
  const { status } = useParams();
  const { setHelpDeskData } = useContext(HelpDeskContext);
  const { fetchData } = HelpdeskService(setHelpDeskData);
  const { REACT_HOOK_FORMS } = FormType;
  const { HEADING, CROP_RESIDUE_LABELS, INFO_TEXT } = STAGE_4;
  const { CROP_RESIDUE, COMMODITY_CROP_TRIGGER } = HEADING;
  const { ADD_CROP_BUTTON } = CROP_RESIDUE_LABELS;
  const isDisabled = isProductDisabled(status);

  const cropResidueLength = watch(COMMODITY_CROP_TRIGGER)?.length;
  const {
    fields: cropResidueFields,
    remove: removeCrop,
    append,
  } = useFieldArray({
    name: DynamicFields.CROP_RESIDUE_DYNAMIC,
  });

  const handleAddCropResidue = () => {
    append(new CropResidue());
    trigger(COMMODITY_CROP_TRIGGER);
  };

  return (
    <>
      <div className={styles.fieldHeaderContainer}>
        <h2
          className={clsx(
            styles.headingContainer,
            styles.headingContainerAlignment
          )}>
          {CROP_RESIDUE}
        </h2>
        <div
          className={clsx(styles.addAction, styles.addActionAlignment, {
            [styles.hideAction]: isDisabled,
          })}>
          <COButton text onClick={handleAddCropResidue}>
            <AddIcon />
            {ADD_CROP_BUTTON}
          </COButton>
        </div>
      </div>
      <div className={styles.populatedFieldInfo}>
        <span className={styles.infoText}>{INFO_TEXT}</span>
      </div>
      <div className={styles.contentContainer}>
        <div className={styles.fieldRow}>
          <div className={styles.formFieldsContainer}>
            <FieldsRow
              {...GetCropResidueInitialField({ fetchData, isDisabled })}
              formType={REACT_HOOK_FORMS}
            />
            {cropResidueFields.map((crops, index) => (
              <div key={crops.id} className={styles.formFieldsContainer}>
                <FieldsRow
                  {...GetCropResidueResidueManagementField({
                    remove: removeCrop,
                    index,
                    cropResidueLength,
                    fetchData,
                    isDisabled,
                  })}
                  formType={REACT_HOOK_FORMS}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default CropResidueSection;
